<template>
  <div v-if="isVisible" class="modal-overlay">
    <div class="modal-content">
       <!-- Фиксированный заголовок модального окна с поиском и кнопкой закрытия -->
      <div class="modal-header">
        <div class="search-input search-input_products">
          <input
            type="text"
            v-model="searchQuery"
            class="input-field clear-btn empty"
            @keydown.enter="onSearch"
            placeholder="Название, ID, артикул или штрих-код"
          />
          <button @click="onSearch" class="btn button button_secondary">Найти</button>
          <button @click="resetSearch" class="btn button button_reset">Сбросить</button>
        </div>
     

        <button @click="closeModal" class="btn-close-modal"></button>

      <div class="filter-tags" >
       
          
        <label><input type="checkbox" id="onlyAvailable" v-model="onlyAvailable" @change="onSearch" />В наличии</label>
        <label><input type="checkbox" value="легковые" v-model="filterTags" @change="onSearch" /> Легковые</label>
        <label><input type="checkbox" value="грузовые" v-model="filterTags" @change="onSearch" /> Грузовые</label>
        <label><input type="checkbox" value="AGM" v-model="filterTags" @change="onSearch" /> AGM</label>
        <label><input type="checkbox" value="EFB" v-model="filterTags" @change="onSearch" /> EFB</label>
        <label><input type="checkbox" value="ИБП" v-model="filterTags" @change="onSearch" /> ИБП</label>
        <label><input type="checkbox" value="Услуга" v-model="filterTags" @change="onSearch" /> Услуги</label>
        <label><input type="checkbox" value="Зарядные" v-model="filterTags" @change="onSearch" /> Зарядные</label>
      </div>
      </div>

      <div v-if="localLoading" class="loader-container">
        <div class="spinner"></div>
      </div>
      <div v-else class="product-list">
       

          <table ref="productTable" class="modern-table list js-order-list batch-tbl">
          <thead>
            <tr>
              <th>Фото</th>
              <th @click="sort('residues')">Наименование</th>
       
              <th @click="sort('tok')">Пуск. ток</th>
              <th @click="sort('emkost')">Емкость</th>
              <th>Дата выпуска</th>
             
              <th colspan="2">Наличие у нас</th>
              <th>Наличие у поставщиков</th>
              <th @click="sort('price')">Цена (руб.)</th>
              <th @click="sort('seba')">Бонус</th>
             
              <th>Количество</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="product in displayedProducts"
              :key="product.id"
              :class="{ 'in-order': isProductInOrder(product.id) }"
            >
              <td style="max-width:50px">
  <img :src="product.jpg_url || 'https://1akb.by/images/no-image_0.webp'" alt="Фото товара" style="max-width:50px"/>
</td>

              <td @click="emitAddProduct(product)" style="position:relative;">
                <a :href="product.href" target="_blank">{{ product.name }}</a><span v-if="product.artikul"> {{ product.artikul }}</span>
                <div class="property">
                  <span v-if="product.korpus">Тип корпуса: {{ product.korpus }}; </span>
                  <span v-if="product.length">Габариты: {{ product.length || product.width || product.height ? 
              `${product.length ? product.length : ''}*${product.width ? product.width : ''}*${product.height ? product.height : ''}` 
              : '' }}; </span>
              <span v-if="product.polarka">Полярность: {{ product.polarka }}; </span> 
              <div class="count">{{ product.count }} <span v-if="product.reserve">({{ product.reserve }})</span> шт</div>
                </div>
                <span v-if="isProductInOrder(product.id)" class="in-order-label">В заказе</span>
              </td>
   
              <td>{{ product.starttok }}</td>
              <td>{{ product.emkost }}</td>
              <td class="gtd-cell">
                <span v-if="product.gtd" class="gtd-value" :title="product.gtd">{{ product.gtd }}</span>
                <span v-else class="gtd-empty">—</span>
              </td>
              
              <!-- Фильтрация склада m через вычисляемое свойство filteredSkladm -->
              <td style="min-width: 85px; text-align: right;">
                <p v-for="m in filteredSkladm(product)" :key="m.id">
                  {{ m.id }} 
                </p>
              </td>
              <td>
                <p v-for="m in filteredSkladm(product)" :key="m.id + '_count'">
                  <span>{{ m.count }} <template v-if="m.reserve">({{ m.reserve }})</template></span>
                </p>
              </td>
              <td>
                <p v-for="p in filteredSkladp(product)" :key="p.id">
                  {{ p.id }} -
                  <span>{{ p.count }}</span>
                </p>
              </td>

              
              <td >{{ product.price }} руб.</td>
              <td >{{ product.seba }}</td>
              
             <td>
                <div class="button_quantity" v-if="isProductInOrder(product.id)">
                <button v-if="isProductInOrder(product.id)" @click.stop="decreaseQuantity(product)" class="qty-btn qty-btn-decrease">-</button>
                <span v-if="isProductInOrder(product.id)" class="quantity">{{ getQuantity(product) }}</span>
                <button v-if="isProductInOrder(product.id)" @click.stop="increaseQuantity(product)" class="qty-btn qty-btn-increase">+</button>
                </div>
                <button v-else @click="emitAddProduct(product)" class="add-btn">Добавить</button>
              </td>
            </tr>
          </tbody>
        </table>

        <div v-if="!displayedProducts.length && !localLoading" class="no-results">
          Ничего не найдено по вашему запросу
        </div>

        <button v-if="hasMoreProducts" @click="loadMore" class="load-more-btn" :disabled="isLoadingMore">
          <span v-if="isLoadingMore" class="spinner"></span>
          <span>Показать еще</span>
        </button>
      </div>
      
    </div>
  </div>
</template>

<script>import { ORDERS_API_BASE } from '@/config/api';

import axios from 'axios';

export default {
  props: {
    products: Array,
    isProductInOrder: Function,
    isVisible: Boolean,
    loading: Boolean,
  },
  data() {
    return {
      searchQuery: '',
      displayedProducts: [],
      itemsPerPage: 30,
      currentPage: 1,
      totalItems: 0,
      filterTags: [],
      currentSort: 'name',
      currentSortDir: 'desc',
      isLoadingMore: false,
      localLoading: this.loading,
      onlyAvailable: true, // По умолчанию включено
    };
  },
  computed: {
    hasMoreProducts() {
      return this.displayedProducts.length < this.totalItems;
    },
   filteredSkladm() {
      return (product) => {
        return product.skladm ? product.skladm.filter(m => m.count > 0) : [];
      };
    },
    filteredSkladp() {
      return (product) => {
        return product.skladp ? product.skladp.filter(p => p.count > 0) : [];
      };
    },
  },
  methods: {
    sort(field) {
      // Меняем направление сортировки, если поле уже выбрано
      if (field === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
      } else {
        this.currentSort = field;
        this.currentSortDir = 'asc';
      }

     

      this.fetchProducts(); // Перезагружаем данные с новыми параметрами сортировки
    },
    getQuantity(product) {
      const selectedProduct = this.products.find(p => p.id === product.id);
      return selectedProduct ? selectedProduct.quantity : 1;
    },
    emitAddProduct(product) {
      if (this.isProductInOrder(product.id)) {
      // Если товар уже добавлен, удаляем его
      this.$emit('remove-product', product.id);
      } else {
        // Если товар не добавлен, добавляем его
        this.$emit('add-product', product);
      }
    },

    increaseQuantity(product) {
      this.$emit('increase-product', product.id);
    },
    decreaseQuantity(product) {
      this.$emit('decrease-product', product.id);
    },
    closeModal() {
      this.$emit('close');
    },
    onSearch() {
      this.currentPage = 1;
      this.fetchProducts();
    },
    resetSearch() {
      this.searchQuery = '';
      this.onSearch();
    },
    loadMore() {
      this.currentPage++;
      this.fetchProducts();
    },
fetchProducts() {
  this.localLoading = this.currentPage === 1;
  this.isLoadingMore = this.currentPage > 1;

  axios
  .get(ORDERS_API_BASE + '/msproduct.php', {
    params: {
      search: this.searchQuery,
      limit: this.itemsPerPage,
      offset: (this.currentPage - 1) * this.itemsPerPage,
      sortField: this.currentSort,
      sortDirection: this.currentSortDir,
      onlyAvailable: this.onlyAvailable ? 1 : 0,
      tags: this.filterTags.join(','), // передаем как CSV
    },
  })
    .then((response) => {
      const { items, totalItems } = response.data;

      if (this.currentPage === 1) {
        this.displayedProducts = items;
      } else {
        this.displayedProducts = [...this.displayedProducts, ...items];
      }

      this.totalItems = totalItems;
      this.scrollToNewItems();
      this.localLoading = false;
      this.isLoadingMore = false;
    })
    .catch((error) => {
      console.error('Ошибка при загрузке товаров:', error);
      this.localLoading = false;
      this.isLoadingMore = false;
    });
},
    scrollToNewItems() {
  this.$nextTick(() => {
    const table = this.$refs.productTable;

    if (table) {
      // Рассчитываем смещение вверх для отображения новых подгруженных элементов
      const firstRow = table.querySelector('tbody tr');
      const rowHeight = firstRow ? firstRow.offsetHeight : 0;
      const rowsToScroll = this.itemsPerPage; // Смещение на количество новых строк
      const scrollOffset = rowHeight * rowsToScroll;

      // Прокручиваем видимость только на высоту подгруженных строк
      table.scrollTop = table.scrollTop + scrollOffset;
    }
  });
}
,
  },
  watch: {
    isVisible(newVal) {
      if (newVal) {
        //this.fetchProducts();
      }
    },
    loading(newVal) {
      this.localLoading = newVal;
    }
  },
};
</script>

<style scoped>
button:not(:disabled), [type=button]:not(:disabled), [type=reset]:not(:disabled), [type=submit]:not(:disabled) {
    cursor: pointer;
    background-color: #fff;
    background-image: linear-gradient(180deg, #fff, #e9ecee);
    border: 1px solid #dee2e6;
    text-shadow: none;
}
.qty-btn {
  margin: 0 4px;
}
.in-order {
  background-color: #f0f8ff;
}
.in-order-label {
  color: #ff4500;
  font-weight: bold;
  margin-left: 4px;
}
.add-btn {
  background-color: #4CAF50;
  color: white;
  border: none;
  padding: 5px 10px;
  cursor: pointer;
  border-radius: 4px;
}

.modal-overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  
}


.modal-content {
    background: white;
    padding: 0px;
    border-radius: 5px;
    max-width: 80%;
    max-height: 80%;
    overflow-y: auto;
    position: relative;
    right: 0;
    left: 0;
    z-index: 1040;
    --default-padding: 56px 296px;
    max-width: 1192px;
    width: 100%;
    height: 100%;
    margin: 40px auto;
    border-radius: 0px;
    background: #fafafa;
    max-height: calc(100vh - 80px);
    overflow: hidden;
    margin: 60px auto 40px auto;
    overflow-y: scroll;
    position: relative;
}

.modal-content {
    background: #ffffff;
    width: 100%;
    max-width: 1340px;
    position: relative;
    overflow-y: auto;
    max-height: 95vh;
}


/* Фиксированный заголовок с поиском и кнопкой закрытия */
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 10;
  padding: 10px;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
  flex-wrap: wrap;
}

.search-input_products {
  display: flex;
  gap: 10px;
  align-items: center;
}

.close-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  color: #ff5353;
}

table.modern-table {
  width: 100%;
  border-collapse: collapse;
}

/* Фиксированные заголовки столбцов таблицы */
table.modern-table thead tr th {
  position: sticky;
  top: 50px; /* отступ от верха */
  background: #ffffff;
  z-index: 5;
}

table.modern-table th,
table.modern-table td {
  border: 1px solid #dee2e6;
  padding: 8px;
  text-align: left;
}

.in-order-label {
  color: #ff4500;
     color: #ff4500;
    font-weight: bold;
    margin-left: 4px;
    background: transparent;
    border: 0px;
    padding: 0px;
    font-size: 12px;
}

.qty-btn, .add-btn {
  margin: 0 4px;
}

.load-more-btn {
  display: block;
  width: 100%;
  margin-top: 10px;
  padding: 10px;
  background-color: #fafafa;
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  color: black;
    font-weight: 500;
}

.qty-btn,
.add-btn {
  margin: 0 4px;
    padding: 8px 12px;
    font-size: 12px;
    font-weight: 500;
    border: none;
    cursor: pointer;
    color: #ffffff;
    border-radius: 5px;
    transition: background 0.3s ease;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

/* Стили для кнопок увеличения и уменьшения */
.qty-btn-decrease {
    color: #000000;
    cursor: pointer;
    background-color: #fff;
    background-image: linear-gradient(180deg, #fff, #e9ecee);
    border: 1px solid #dee2e6;
    text-shadow: none;
    box-shadow: none;
    font-weight: 600;
}

.bonus {
      background: #e4ffe4;
    margin-left: 6px;
    font-size: 10px;
    border: solid 1px #dee2e6;
    }

    .nobonus {
      background: #ff787838;
    margin-left: 6px;
    font-size: 10px;
    border: solid 1px #00000038;
    }

.qty-btn-increase {
  
    color: #000000;
    cursor: pointer;
    background-color: #fff;
    background-image: linear-gradient(180deg, #fff, #e9ecee);
    border: 1px solid #dee2e6;
    text-shadow: none;
    box-shadow: none;
}

.qty-btn:hover {
  opacity: 0.8;
}

.add-btn {
    background-color: #4CAF50!important;
    background-image: linear-gradient(180deg, #22c993, #20a77f)!important;
    color: #fff;
    width: 67%;
}

.load-more-btn {
  display: block;
  width: 100%;
  margin-top: 10px;
  padding: 10px;
  background-color: #fafafa;
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  color: black;
    font-weight: 500;
}

.load-more-btn:hover {
  background-color: #fafafa;
}

.button_quantity {
  display:flex;
  align-items:center;
  justify-content:center;
}

.input-field.clear-btn.empty {
  min-width: 250px;
  min-height: 35px;
}

.btn-close-modal:before {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24'%3E%3Cpath fill='%23FF5353' d='M7.113 6.176a.6.6 0 0 1 .848 0L12 10.214l4.038-4.038a.6.6 0 0 1 .849 0l.937.937a.6.6 0 0 1 0 .848L13.785 12l4.04 4.04a.6.6 0 0 1 0 .848l-.937.937a.6.6 0 0 1-.849 0L12 13.784l-4.038 4.04a.6.6 0 0 1-.849 0l-.937-.937a.6.6 0 0 1 0-.848l4.04-4.04-4.039-4.038a.6.6 0 0 1 0-.849l.937-.936Z'/%3E%3C/svg%3E");
    background-position: 50%;
    background-repeat: no-repeat;
    bottom: 0;
    content: "";
    height: 24px;
    left: 0;
    margin: auto;
    position: absolute;
    right: 0;
    top: 0;
    width: 24px;
}

.btn-close-modal {
  width: 35px;
    height: 35px;
    position: relative;
    border-radius: 6px;
}

.btn-close-modal:hover {
  opacity:.5;
}

.spinner {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 3px solid rgba(0, 123, 255, 0.3); /* полупрозрачная обводка */
  border-radius: 50%;
  border-top-color: #007bff; /* синяя обводка сверху */
  animation: spin 1s ease-in-out infinite;
  margin-right: 8px;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.load-more-btn {
  display: flex;
    align-items: center;
    justify-content: center;
}

.add-btn:hover {
  opacity:.5;
}


.modern-table tr:hover {
    background-color: #f9fafb;
    cursor: pointer;
}

.qty-btn:hover {
  opacity:.5;
}

td p{
    margin-bottom: 2px;
    font-size: 12px;
    line-height: 14px;
}

td span{
    background: #ffc107;
    padding: 0px 4px;
    font-size: 10px;
    border: solid 1px #c7b0b0;
}

.quantity {
  background: transparent;
    border: 0px;
    font-size: 12px;
}

a {
    color: rgb(0 0 0);
    text-decoration: none;
    display: block;
}

.property {
    margin-top: 4px;
}

td .property span {
    background: transparent;
    padding: 0px;
    font-size: 10px;
    border: solid 0px #c7b0b0;
    margin: 0px;
}


.count {
    position: absolute;
    top: 5px;
    right: 5px;
    font-size: 10px;
    color: #6c757d;
}

.no-results {
  text-align: center;
  padding: 20px;
  font-size: 16px;
  color: #999;
}

.gtd-cell {
  max-width: 120px;
  font-size: 12px;
  word-break: break-word;
}
.gtd-value {
  color: #1a4a7a;
  font-weight: 600;
}
.gtd-empty {
  color: #adb5bd;
}

.filter-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-left: 0px;

  margin-top: 20px;
  width: 100%;
}

.filter-tags label {
  font-size: 13px;
  background: linear-gradient(180deg, #fff, #e9ecee);
  padding: 6px 10px;
  border-radius: 4px;
  cursor: pointer;
  border: solid 1px #dee2e6;
}
.filter-tags input[type="checkbox"] {
  margin-right: 5px;
}

</style>
